/**
 * @generated SignedSource<<66a9079f279dc0aab01b4b6e9d5e2438>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrderEditMainGeneral_order$data = {
  readonly duration: number;
  readonly name: string;
  readonly tripDateEnd: string;
  readonly tripDateStart: string;
  readonly " $fragmentType": "OrderEditMainGeneral_order";
};
export type OrderEditMainGeneral_order$key = {
  readonly " $data"?: OrderEditMainGeneral_order$data;
  readonly " $fragmentSpreads": FragmentRefs<"OrderEditMainGeneral_order">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OrderEditMainGeneral_order",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tripDateStart",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tripDateEnd",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "duration",
      "storageKey": null
    }
  ],
  "type": "Order",
  "abstractKey": null
};

(node as any).hash = "f91e64527ac9fc9c3d2c40a3502ea20c";

export default node;
